export const PAGE_TYPES = {
    CATEGORY: "category",
    GIFT_CARD: "gift card",
    IN_STORE: "in-store",
} as const;

export type BreadcrumbLinkProps = {
    name: string;
    rootPageUrl: string;
    description?: string;
    id?: string;
    parentId?: string;
};

export type PAGE_TYPE = typeof PAGE_TYPES[keyof typeof PAGE_TYPES];
